import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import ButtonWithSVG from "../../../Components/layouts/button_with_svg";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcMoneyTransfer, FcRules, FcServiceMark } from "react-icons/fc";
import ScrumTable from "./scrum_meeting_table";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const ScrumMeetings = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);

  const location = useLocation(); // ✅ add this
 const navigate = useNavigate(); 

  // ✅ ADD THIS HERE
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromUrl = parseInt(params.get("page")) || 1;
    setPage(pageFromUrl);
  }, []);

  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    title: "",
    conductMetting: "",
  });
  const store = useSelector((store) => store.login.user);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    navigate({ search: params.toString() }, { replace: true });
  }, [page]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/scrumMeeting/getscrumMeetings", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.scrumMeetings);
          setTotalPages(Math.ceil(res.data?.scrumMeetingCount / 50));
        } else {
          Toast("error", "Error while getting RFP!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcServiceMark />
                    All Scrum Meetings
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
                <div className="col-auto ms-auto d-print-none">
                  {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                  store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                  store.Role === process.env.REACT_APP_ROLE_HR ||
                  store.Role === process.env.REACT_APP_ROLE_JR_HR ? (
                    <div className="d-flex d-none d-sm-block">
                      <ButtonWithSVG
                        href={"/conduct-new-scrum"}
                        buttonText="Conduct New Scrum Meeting"
                        svg={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search Title:"
                                  value={filters.title}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      title: e.target.value,
                                    })
                                  }
                                  placeholder="Search Title:..."
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Select Scrum / Demo:"
                                  value={filters.conductMetting}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      conductMetting: e.target.value,
                                    })
                                  }
                                  type="text"
                                >
                                  <option value="">Select</option>
                                  <option value="Scrum">Scrum</option>
                                  <option value="Demo">Demo</option>
                                </DynamicFilterSelect>
                              </div>

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          title: "",
                                          conductMetting: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>

                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search Title:"
                                value={filters.title}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    title: e.target.value,
                                  })
                                }
                                placeholder="Search Title:..."
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Select Scrum / Demo:"
                                value={filters.conductMetting}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    conductMetting: e.target.value,
                                  })
                                }
                                type="text"
                              >
                                <option value="">Select</option>
                                <option value="Scrum">Scrum</option>
                                <option value="Demo">Demo</option>
                              </DynamicFilterSelect>
                            </div>

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        title: "",
                                        conductMetting: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && (
                      <ScrumTable
                        data={data}
                        currentPage={page}
                        itemsPerPage={50}
                      />
                    )}

                    <div className="btn-list justify-content-center">
                      {store.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      store.Role === process.env.REACT_APP_ROLE_ADMIN ||
                      store.Role === process.env.REACT_APP_ROLE_HR ||
                      store.Role === process.env.REACT_APP_ROLE_JR_HR ? (
                        <div className="d-lg-none d-md-none mt-3 mb-3">
                          <ButtonWithSVG
                            href={"/conduct-new-scrum"}
                            buttonText="Conduct New Scrum Meeting"
                            svg={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path
                                  stroke="none"
                                  d="M0 0h24v24H0z"
                                  fill="none"
                                />
                                <path d="M12 5l0 14" />
                                <path d="M5 12l14 0" />
                              </svg>
                            }
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ScrumMeetings;
